// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__0DS+M","fadeInDownMenu":"PrivacyPolicy_fadeInDownMenu__t9lA4"};